// extracted by mini-css-extract-plugin
export default {"CheckboxContainer":"CheckboxElement_CheckboxContainer__f7kPR"};